import React from 'react';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import moment from 'moment';

const EmailSchedule = () => (
  <Flex mt='small' items='center'>
    <Text size='large' weight={400} mr='0.5rem'>
      Monthly Update: Our next email will be sent on
    </Text>
    <Text size='large' weight={700}>
      {moment().add(1, 'month').startOf('month').format('MMMM Do, YYYY')}
    </Text>
  </Flex>
);
export default EmailSchedule;
